import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { API } from "../../config/api";
import { FaSync, FaFileInvoiceDollar, FaLock, FaCalendarAlt } from "react-icons/fa";
import "bulma/css/bulma.css";
import "../../index.css";
import swal from "sweetalert";
import LoaderHome from "../Loader/LoaderHome";
import ModalPassword from "../ListTeacherSalarySlip/ModalPassword";
import SlipGajiModal from "../ListTeacherSalarySlip/SlipGajiModal";

// Helper format rupiah
const formatRupiah = (number) => {
  if (number === null || number === undefined || isNaN(number)) return "Rp 0";
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(number);
};

export default function ListTeacherSalarySlip() {
  document.title = "Slip Gaji";
  const [getData, setGetData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Security / Password & Detail Modal State
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showSlipModal, setShowSlipModal] = useState(false);
  const [selectedSlip, setSelectedSlip] = useState(null);

  const token = localStorage.getItem("token");
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });

  const currentYear = new Date().getFullYear();
  const arrayTahun = [currentYear - 2, currentYear - 1, currentYear, currentYear + 1, currentYear + 2];

  const [form, setForm] = useState({
    month: "",
    year: String(currentYear),
  });

  let fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  const GetTeacherSalarySlips = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        month: form.month,
        year: form.year,
      });

      const response = await API.get(`/api/salary-slips-teacher?${params.toString()}`, fetchParams);

      if (response?.status === 200) {
        setGetData(response.data.data || []);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      swal({
        title: "Gagal Mengambil Data",
        text: error?.response?.data?.message || "Terjadi kesalahan saat memuat slip gaji Anda.",
        icon: "error",
      });
    }
  };

  useEffect(() => {
    GetTeacherSalarySlips();
  }, []);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleOpenSlip = (slip) => {
    setSelectedSlip(slip);
    setShowPasswordModal(true);
  };

  const handlePasswordSuccess = (slip) => {
    setShowPasswordModal(false);
    setSelectedSlip(slip);
    setShowSlipModal(true);
  };

  return (
    <div style={{ padding: isTabletOrMobile ? "10px" : "20px", fontFamily: "Poppins, sans-serif" }}>
      {/* Header Banner */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#ffffff",
          padding: "16px 20px",
          borderRadius: "10px",
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          marginBottom: "20px",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <div>
          <h4 style={{ margin: 0, fontWeight: "bold", color: "#00487F", display: "flex", alignItems: "center", gap: "10px" }}>
            <FaFileInvoiceDollar /> Slip Gaji
          </h4>
          <p style={{ margin: "4px 0 0 0", fontSize: "13px", color: "#6b7280" }}>
            Lihat dan cetak rincian slip gaji bulanan Anda secara mandiri dan aman.
          </p>
        </div>

        <button
          onClick={GetTeacherSalarySlips}
          title="Refresh Data"
          style={{
            padding: "9px 14px",
            borderRadius: "8px",
            backgroundColor: "#f3f4f6",
            color: "#00487F",
            border: "1px solid #d1d5db",
            cursor: "pointer",
          }}
        >
          <FaSync /> Refresh
        </button>
      </div>

      {/* Filter Card (Hanya Periode & Tahun untuk Guru) */}
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "16px 20px",
          borderRadius: "10px",
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          marginBottom: "20px",
        }}
      >
        <div style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "12px", display: "flex", alignItems: "center", gap: "6px" }}>
          <FaCalendarAlt color="#00487F" /> Pilih Periode Slip Gaji
        </div>

        <div className="row g-2 align-items-end">
          {/* Periode / Bulan */}
          <div className="col-md-5 col-12">
            <label style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", display: "block" }}>Bulan / Periode</label>
            <select
              value={form.month}
              name="month"
              onChange={handleChange}
              style={{
                width: "100%",
                border: "1px solid #3272B3",
                borderRadius: "6px",
                height: "38px",
                fontSize: "13px",
                padding: "0 8px",
              }}
            >
              <option value="">Semua Periode</option>
              <option value="1">Desember-Januari (1)</option>
              <option value="2">Januari-Februari (2)</option>
              <option value="3">Februari-Maret (3)</option>
              <option value="4">Maret-April (4)</option>
              <option value="5">April-Mei (5)</option>
              <option value="6">Mei-Juni (6)</option>
              <option value="7">Juni-Juli (7)</option>
              <option value="8">Juli-Agustus (8)</option>
              <option value="9">Agustus-September (9)</option>
              <option value="10">September-Oktober (10)</option>
              <option value="11">Oktober-November (11)</option>
              <option value="12">November-Desember (12)</option>
            </select>
          </div>

          {/* Tahun */}
          <div className="col-md-5 col-12">
            <label style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", display: "block" }}>Tahun</label>
            <select
              value={form.year}
              name="year"
              onChange={handleChange}
              style={{
                width: "100%",
                border: "1px solid #3272B3",
                borderRadius: "6px",
                height: "38px",
                fontSize: "13px",
                padding: "0 8px",
              }}
            >
              <option value="">Semua Tahun</option>
              {arrayTahun.map((th, idx) => (
                <option key={idx} value={String(th)}>
                  {th}
                </option>
              ))}
            </select>
          </div>

          {/* Tombol Tampilkan */}
          <div className="col-md-2 col-12">
            <label style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", display: "block", visibility: "hidden" }}>Aksi</label>
            <button
              onClick={GetTeacherSalarySlips}
              style={{
                width: "100%",
                height: "38px",
                backgroundColor: "#00487F",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                fontSize: "13px",
                fontWeight: "500",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Tampilkan
            </button>
          </div>
        </div>
      </div>

      {/* List / Table Card */}
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
        }}
      >
        <div style={{ fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "16px" }}>
          Daftar Arsip Slip Gaji Anda
        </div>

        {loading ? (
          <div style={{ padding: "40px 0", textAlign: "center" }}>
            <LoaderHome />
          </div>
        ) : (
          <div className="table-responsive">
            <style>{`
              .teacher-salary-table thead th {
                background-color: #00487F !important;
                color: #ffffff !important;
                text-align: center !important;
                vertical-align: middle !important;
                border-color: #003865 !important;
                font-weight: 600 !important;
                padding: 10px 8px !important;
              }
              .teacher-salary-table tbody td {
                text-align: center !important;
                vertical-align: middle !important;
              }
            `}</style>
            <table className="table table-hover table-bordered teacher-salary-table" style={{ fontSize: "13px", verticalAlign: "middle" }}>
              <thead style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>
                <tr>
                  <th style={{ width: "50px", backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>No</th>
                  <th style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>Periode Gaji</th>
                  <th style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>No. Rekening</th>
                  {/* <th style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>Total Pendapatan</th> */}
                  {/* <th style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>Total Potongan</th> */}
                  {/* <th style={{ backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>Penghasilan Bersih (Ditransfer)</th> */}
                  <th style={{ width: "140px", backgroundColor: "#00487F", color: "#ffffff", textAlign: "center" }}>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {getData && getData.length > 0 ? (
                  getData.map((item, index) => {
                    const ditransferVal = item.ditransfer || item.total_pendapatan - item.jumlah_potongan || 0;
                    return (
                      <tr key={item.id || index}>
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{index + 1}</td>
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          <span
                            style={{
                              backgroundColor: "#e0f2fe",
                              color: "#0369a1",
                              padding: "4px 10px",
                              borderRadius: "4px",
                              fontWeight: "600",
                              fontSize: "12px",
                              display: "inline-block",
                            }}
                          >
                            {item.periode || "-"}
                          </span>
                        </td>
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.no_rek_bni || "-"} (BNI)</td>
                        {/* <td style={{ textAlign: "center", verticalAlign: "middle", color: "#166534", fontWeight: "600" }}>
                          {formatRupiah(item.total_pendapatan)}
                        </td>
                        <td style={{ textAlign: "center", verticalAlign: "middle", color: "#991b1b", fontWeight: "600" }}>
                          {formatRupiah(item.jumlah_potongan || item.rekap_potongan)}
                        </td>
                        <td style={{ textAlign: "center", verticalAlign: "middle", fontWeight: "bold", color: "#00487F", fontSize: "14px" }}>
                          {formatRupiah(ditransferVal)}
                        </td> */}
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          <button
                            onClick={() => handleOpenSlip(item)}
                            style={{
                              backgroundColor: "#00487F",
                              color: "#ffffff",
                              border: "none",
                              padding: "6px 14px",
                              borderRadius: "6px",
                              fontSize: "12px",
                              fontWeight: "500",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "6px",
                            }}
                          >
                            <FaLock style={{ fontSize: "11px" }} /> Buka Slip Gaji
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={7} style={{ textAlign: "center", padding: "30px", color: "#6b7280" }}>
                      Belum ada data slip gaji untuk periode yang dipilih.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal Verifikasi Password */}
      <ModalPassword
        show={showPasswordModal}
        handleClose={() => setShowPasswordModal(false)}
        targetSlip={selectedSlip}
        onSuccess={handlePasswordSuccess}
      />

      {/* Modal Detail Slip Gaji (Printable) */}
      <SlipGajiModal
        show={showSlipModal}
        handleClose={() => setShowSlipModal(false)}
        data={selectedSlip}
      />
    </div>
  );
}
